import abeagle from './abeagle';

const testSlug = 'hp_entry_cta_ml_test';
const {
  edition, isEntry, features, clientUUID: originalClientUUID, abeagle: abeagleArr,
} = window.HP.params;
const { adsFree } = features;
const isLife = window.HP?.entry?.departmentSlug === 'lifestyle';
const isUS = edition === 'us';

// Allow clientUUID override via query param ONLY on staging or local
let clientUUID = originalClientUUID;
const url = window.location.href;
if (url.startsWith('https://staging.www.') || url.startsWith('https://local.www.')) {
  const params = new URLSearchParams(window.location.search);
  const override = params.get('clientUUID');
  if (override) clientUUID = override;
}

const CACHE_KEY = `hp_cta_ml_${clientUUID}`;
const CACHE_MAX_AGE = 12 * 60 * 60 * 1000; // 12 hours in ms

function getCachedResult() {
  try {
    const cached = sessionStorage.getItem(CACHE_KEY);
    if (!cached) return null;
    const { data, ts } = JSON.parse(cached);
    if (Date.now() - ts < CACHE_MAX_AGE) {
      return data;
    }
    sessionStorage.removeItem(CACHE_KEY);
    return null;
  } catch {
    return null;
  }
}

function setCachedResult(data) {
  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify({ data, ts: Date.now() }));
  } catch { console.log('Failed to set cache for hp_cta_ml'); }
}

function updateOutbrainModulesForMlTest() {
  // outbrain module AR_1 is the one used in all article pages currently.
  const outbrainModules = document.querySelectorAll('.outbrain-module .OUTBRAIN[data-widget-id="AR_1"]');

  outbrainModules.forEach((module) => {
    module.setAttribute('data-widget-id', 'AR_10'); // Update widget id to AR_10 for the ml test
  });
}

function addOutbrainScript() {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = '//widgets.outbrain.com/outbrain.js';
  document.head.appendChild(script);
}

const bodyElement = document.querySelector('body');

if (isUS && isEntry && !adsFree && abeagleArr && Array.isArray(abeagleArr) && abeagleArr.includes(testSlug)) {
  // Select all support elements by class (could be more than one)
  const supportElements = document.querySelectorAll('.cli-support-huffpost');
  if (!isLife) {
    document.addEventListener(
      'abeagleEventCambria',
      async () => {
        const variant = abeagle.getExperimentVariant(testSlug);
        if (variant && variant === 'variant1') {
          let data = getCachedResult();
          if (!data) {
            try {
              const resp = await fetch(
                `https://recsys-api.buzzfeed.com/web/ml/huffpost_membership_ctr?client_uuid=${clientUUID}`,
              );
              data = await resp.json();
              setCachedResult(data);
            } catch (e) {
              // On error, update links data-vars-subunit-name (for tracking) and show all support elements
              supportElements.forEach((el) => {
                el.querySelectorAll('a').forEach((link) => {
                  const oldVal = link.getAttribute('data-vars-subunit-name') || '';
                  link.setAttribute('data-vars-subunit-name', `${oldVal}_fallback`);
                });
                el.classList.remove('hidden');
              });
              window.doImpressions('supportBpageModule');
              addOutbrainScript();
              return;
            }
          }
          if (!Array.isArray(data) || data.length === 0 || (Array.isArray(data[0]) && String(data[0][0]).startsWith('show_cta:1'))) {
            if (!Array.isArray(data) || data.length === 0) {
              // this is fallback case
              supportElements.forEach((el) => {
                el.querySelectorAll('a').forEach((link) => {
                  const oldVal = link.getAttribute('data-vars-subunit-name') || '';
                  link.setAttribute('data-vars-subunit-name', `${oldVal}_fallback`);
                });
                el.classList.remove('hidden');
              });
              window.doImpressions('supportBpageModule');
              addOutbrainScript();
              bodyElement.classList.add(`ab-${testSlug}`);
              return;
            }
            // this means 'show_cta:1' is present in the data so we show all ctas
            supportElements.forEach((el) => el.classList.remove('hidden'));
            window.doImpressions('supportBpageModule');
          }
          // for all cases where the ml test is running, we are in variatn1 and the cliendUUID is known (we have either 'show_cta:0' or 'show_cta:1')
          // we need to update the outbrain module and load the outbrain script
          updateOutbrainModulesForMlTest();
          addOutbrainScript();
        } else {
          // Not variant1, show all support elements then load outbrain script
          supportElements.forEach((el) => el.classList.remove('hidden'));
          window.doImpressions('supportBpageModule');
          addOutbrainScript();
        }
        bodyElement.classList.add(`ab-${testSlug}`);
      },
      { once: true },
    );
  } else {
    // We are in life entry which is not part of the test, we should load all outbrain modules and scripts and also show all ctas
    supportElements.forEach((el) => el.classList.remove('hidden'));
    window.doImpressions('supportBpageModule');
    addOutbrainScript();
    bodyElement.classList.add(`ab-${testSlug}`);
  }
  window.HP.params.abEntryCtaMlTest.ready = true;
}
